export default __webpack_public_path__ + "static/media/Q8_4_resized.0442b4fe.jpg";